import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AdmissionPageComponent } from './admission.page.component';
import {
  getAdmissionRoot,
  getAdmissionCategoryById,
  getAdmissionCategoriesById,
} from 'shared/store/selectors/admission.selector';
import { getSelectedWorkspace } from 'shared/store/selectors/workspace.selector';

const mapStateToProps = ({ admission, workspace }, ownProps) => {
  let category;
  let { id } = ownProps;
  let isRoot = false;

  if (id) {
    category = id ? getAdmissionCategoryById(admission, { id }) : {};
  } else {
    category = getAdmissionRoot(admission);
    id = category?.id;
    isRoot = true;
  }

  const workspaceName = getSelectedWorkspace({ workspace })?.name;

  return {
    id,
    category: {
      ...category,
      title: isRoot ? workspaceName : category.title,
    },
    showBreadcrumbs: !isRoot,
    children: getAdmissionCategoriesById(admission, id) || [],
    isReady: admission.isReady,
  };
};

const ConnectedAdmissionPage = connect(mapStateToProps, {})(AdmissionPageComponent);

export const AdmissionPage = () => {
  const params = useParams();
  return <ConnectedAdmissionPage {...params} />;
};
